import 'COMMON';
import { oLikeDislike } from 'Lib/like-dislike/like-dislike';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { oLike } from 'Lib/like/like';
import 'Bem/site/radio/radio';
import 'Bem/site/checkbox/checkbox';
import 'Bem/site/sale/sale';
import 'Bem/site/filter-slider/filter-slider';
import 'Bem/site/filter-formats/filter-formats';
import 'Bem/site/sales/sales';
import 'Bem/journal/article-share/article-share';
import 'Bem/site/book/book';
import 'Bem/site/promo/promo';
import 'Bem/site/books-slider/books-slider';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';
import 'Bem/site/together-cheaper/together-cheaper';
import 'Bem/site/popup18/popup18';
import 'Bem/site/copy/copy';

svgSpriteLoader('/site/sales/svg/sprite.svg');
oLike.init('.js-book-like, .js-like');
oLikeDislike.init('.js-like-dislike');

$('body').on('eksmoPagenavAjax', () => {
    oLikeDislike.init('.js-like-dislike');
}).on('like.eksmo', () => {
    oLike.init('.js-book-like, .js-like');
});

$('.js-m-menu-filter-catalog-last-lvl').on('eksmoSetMMenu', function () {
    const $this = $(this);
    const sCheckbox = '.js-filter-catalog-last-lvl-checkbox';
    const sRadioFormatLabels = '.js-filter-catalog-last-lvl-radio-format';
    const sRadioPriceLabels = '.js-filter-catalog-last-lvl-radio-price';
    const sRadioAgeLabels = '.js-filter-catalog-last-lvl-radio-age';
    const $submitLink = $this.find('.js-filter-catalog-last-lvl-submit').first();
    const oldHref = $submitLink.attr('href') || '';

    function setUrl() {
        const arrUrl = [];

        $this.find(sCheckbox).each(function () {
            const $thisCheckbox = $(this);

            if (!$thisCheckbox.closest('.m-menu__item-result-finder-template').length) {
                const value = $thisCheckbox.find('input:checked').length ? $thisCheckbox.attr('data-filter-catalog-last-lvl-y') : $thisCheckbox.attr('data-filter-catalog-last-lvl-n');

                if (isNoEmptyString(value)) {
                    arrUrl.push(value);
                }
            }
        });

        $this.find(sRadioFormatLabels).each(function () {
            const $thisLabel = $(this);

            if ($thisLabel.find('input:checked').length) {
                const data = $thisLabel.attr('data-filter-catalog-last-lvl');

                if (isNoEmptyString(data)) {
                    arrUrl.push(data);
                }
            }
        });

        $this.find(sRadioPriceLabels).each(function () {
            const $thisLabel = $(this);

            if ($thisLabel.find('input:checked').length) {
                const data = $thisLabel.attr('data-filter-catalog-last-lvl');

                if (isNoEmptyString(data)) {
                    arrUrl.push(data);
                }
            }
        });

        $this.find(sRadioAgeLabels).each(function () {
            const $thisLabel = $(this);

            if ($thisLabel.find('input:checked').length) {
                const data = $thisLabel.attr('data-filter-catalog-last-lvl');

                if (isNoEmptyString(data)) {
                    arrUrl.push(data.replace('+', 'plus'));
                }
            }
        });

        $submitLink.removeClass('btn_disabled');
        $submitLink.attr('href', oldHref + ((oldHref.indexOf('?') + 1) ? '&' : '?') + arrUrl.join('&'));
    }

    if ($submitLink.length) {
        $this.on('eksmoChangeCheckbox', sCheckbox, setUrl);
        $this.on('eksmoChangeRadio', sRadioFormatLabels, setUrl);
        $this.on('eksmoChangeRadio', sRadioPriceLabels, setUrl);
        $this.on('eksmoChangeRadio', sRadioAgeLabels, setUrl);
    }
});